import { Container, ContainerProps } from "@mui/material"
import { Root } from "./styles"

export const ContainerPage = ({ children }: ContainerProps) => {
  return <Root>{children}</Root>
}
